import Backbone from 'backbone';
import BaseAPI from '../services/BaseAPI';
import Tools from '../services/Tools';
import 'regenerator-runtime/runtime';

const queryString = require('query-string');

const MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);
let timefocusLink = '';

const FrameView = require('./FrameView');
const MinimizePanelView = require('./minimize/MinimizePanelView');
const MinimizePanelModel = require('../model/minimize/MinimizePanelModel');
const ExpandChatPanelView = require('./expand/ExpandPanelView');
const ExpandChatPanelModel = require('../model/expand/ExpandPanelModel');

const SocketManagerModel = require('./socket/SocketManagerModel');
const SocketManagerView = require('./socket/SocketManagerView');

const $ = Backbone.$;

module.exports = Backbone.View.extend({
  initialize(o) {
    _.bindAll(
      this,
      'init',
      'renderBody',
      'handleChatOpen',
      'handleGreeting',
      'handleStopGreeting',
      'endConversation',
      'focusTime',
      'handleStopTime',
      'getDataMessages',
      'handleNumberMess',
      'handleSocketSendCookie',
      'handleSocketReceiveMessage',
      'handleSocketDisconnected',
      'handleSocketEndChat',
      'handleFetchConfig',
      'sendMessageCallback',
      'handleSocketDisconnectChanged',
      'processRenderBody'
    );
    this.config = o.config || {};
    this.pfx = this.config.stylePrefix || '';
    // init
    this.init();
  },

  init() {
    const { model, config } = this;
    // init socket
    this.socketModel = new SocketManagerModel(this.config);
    this.socketManager = new SocketManagerView({
      model: this.socketModel,
      config: this.config
    });

    // listener socket event
    this.listenTo(
      this.socketModel,
      'onSendCookie',
      this.handleSocketSendCookie
    );
    this.listenTo(
      this.socketModel,
      'onReceiveMessage',
      this.handleSocketReceiveMessage
    );
    this.listenTo(
      this.socketModel,
      'onDisconnected',
      this.handleSocketDisconnected
    );
    this.listenTo(this.socketModel, 'onEndChat', this.handleSocketEndChat);
    this.listenTo(
      this.socketModel,
      'change:disconnect',
      this.handleSocketDisconnectChanged
    );

    config.socket = this.socketManager;

    const parsed = queryString.parse(location.search);
    this.config.userId = parsed && parsed.userId;
    if (this.config.userId) {
      this.socketManager.connect();
    }
    // get config;
    this.fetchConfig();
  },

  async fetchConfig() {
    var confix = {
      url: `${this.config.domainAPI}/chat/${this.config.domain_id}/config`,
      method: 'get',
      body: ''
    };
    this.focusTime();
    this.config.focusTime = true;
    const { config, $el, frame } = this;
    const response = await BaseAPI.fetchConfig(confix, null);
    if (response.code == 200) {
      this.handleFetchConfig(response);
      return;
    }
    if (this.$el.find('.mo-chat-frame')[0]) {
      this.$el
        .find('.mo-chat-frame')[0]
        .style.setProperty('display', 'none', 'important');
    }

    // if (this.$el.find('.mo-chat-frame')[0]) {
    //   this.$el
    //     .find('.mo-chat-frame')[0]
    //     .style.setProperty('display', 'none', 'important');
    // }
  },

  handleFetchConfig(response) {
    const { config, $el, frame } = this;
    // update config
    Tools.updateConfig(config, response);
    // Neu khong phai facebook message hoac live chat
    if (!config.widget_config.messenger && !config.widget_config.mobiochat) {
      return;
    }
    // neu la mo messenger popup
    if (config.messenger_config.open_popup) {
      if (config.messenger_setting.is_show_greeting) {
        Tools.addMessFaceBook(
          config.pageID,
          config.messenger_config.frame_color,
          config.messenger_setting.message
        );
      } else {
        Tools.addMessFaceBook(
          config.pageID,
          config.messenger_config.frame_color,
          ''
        );
      }
      config.isTypeShow = 'podFBAndChat';
      if (config.widget_config.messenger && !config.widget_config.mobiochat) {
        config.isTypeShow = 'facebook';
      }
    }
    // Neu la mo messenger o tab moi
    if (config.messenger_config.open_in_new_tab) {
      config.isTypeShow = 'tabFBAndChat';
      if (config.widget_config.messenger && !config.widget_config.mobiochat) {
        config.isTypeShow = 'tabFacebook';
      }
    }
    // chi dung live chat
    if (!config.widget_config.messenger && config.widget_config.mobiochat) {
      config.isTypeShow = 'chat';
    }

    config.urlFB = `http://m.me/${config.pageID}`;
    if (config.isTypeShow == 'facebook') {
      showFB();
      return;
    }

    // process render body
    this.processRenderBody();
  },

  processRenderBody() {
    if (this.loaded) {
      return;
    }
    if (this.isFrameRender) {
      this.loaded = true;
      // update config
      this.frame.updateConfig();
      if (!this.config.userId) {
        this.socketManager.connect();
      }
      setTimeout(() => {
        this.initWindowEvent();
        this.renderBody();
      }, 0);
      return;
    }
    setTimeout(() => {
      this.processRenderBody();
    }, 50);
  },

  renderBody() {
    const { pfx, config, handleGreeting } = this;
    this.frameBody = $(this.frame.getBody());
    const head = $(this.frame.getHeader());
    this.frameBody.attr('class', `${pfx}body`);
    head.append(
      `<link rel="stylesheet" href="${config.domain}css/mo.chat.min.css" />`
    );
    head.append(
      `<link href="https://fonts.googleapis.com/css?family=Roboto:ital:wght@0,300;0,400;0,700|Roboto+Slab:wght@700" rel='stylesheet' type='text/css' />`
    );
    head.append(`<script src="${config.domain}js/jquery.min.js" />`);
    head.append(
      `<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"/>`
    );
    head.append(`
      <style>
        .rf {
          font-family: 'Roboto', Helvetica,Arial,sans-serif !important;
          font-weight: 300;
          ${
            md.mobile()
              ? ` font-size: 16px !important; line-height: 22px !important;`
              : ``
          }
        }
        .mf {
          font-family: 'Roboto', Helvetica,Arial,sans-serif !important;
          font-weight: 400;
          ${
            md.mobile()
              ? ` font-size: 16px !important; line-height: 22px !important;`
              : ``
          }
        }
        .bf {
          font-family: 'Roboto', Helvetica,Arial,sans-serif !important;
          font-weight: 700;
          ${
            md.mobile()
              ? ` font-size: 16px !important; line-height: 22px !important;`
              : ``
          }
        }
      </style>
    `);
    // init chat
    this.initExpandChatPanel();
    // Neu la fix user, mo chat
    if (this.config.userId) {
      this.openChatPanel();
    } else {
      this.renderMinimizeChatPanel();
    }
    const greeting = Tools.getGreeting(config.domain_id);
    if (!greeting) {
      // this.handleStopGreeting();
      if (config.time_popup > 0) {
        this.openchat = setTimeout(() => {
          handleGreeting();
        }, 1000 * config.time_popup);
      }
    }
  },

  /**
   * handle socket send cookie
   */
  handleSocketSendCookie(userId, sessionId) {
    if (!sessionId) {
      this.config.dataLoaded = true;
    }
    this.getDataMessages(userId, sessionId);
  },

  /**
   * handle receive message socket
   * @param {*} msg
   */
  handleSocketReceiveMessage(msg) {
    if (!msg || !msg.sender) {
      return;
    }
    const { model, config } = this;
    const expOpen = this.expModel && this.expModel.get('open');
    config.dataLoaded = true;
    if (
      !expOpen &&
      msg.sender.sender_type != 'VISITOR' &&
      !config.flagGreeting
    ) {
      const number = (model.get('numberMess') || 0) + 1;
      this.handleNumberMess(number);
      model.set('numberMess', number);
    }
    if (expOpen) {
      model.set('numberMess', 0);
    }
    this.expView && this.expView.receiveMessage(msg);
    // play sound
    this.playSound(msg);
    // show chat panel
    if (config.flagGreeting && !expOpen) {
      config.flagGreeting = false;
      this.minimizeView.showLiveChat();
    }
  },

  /**
   * play sound
   * @param {*} msg
   */
  playSound(msg) {
    const { config } = this;
    const ringtone = Tools.getRingtone(config.domain_id);
    if (
      !ringtone &&
      config.bell_notifi &&
      msg.sender.sender_type != 'VISITOR'
    ) {
      try {
        var audio = new Audio(`${config.domain}audio/SMSIPhoneringtone.mp3`);
        if (audio) {
          audio.muted = false;
          audio.play();
        }
      } catch (e) {
        console.log('audio play error', e);
      }
    }
  },

  handleSocketDisconnected() {},

  handleSocketDisconnectChanged(model, val, options) {
    this.getDataMessages();
  },

  handleSocketEndChat() {
    const { config } = this;
    this.handleChatClose();
    this.getDataMessages();
  },

  getDataMessages() {
    const { model, $el, config } = this;
    const sessionId = Tools.getSessionId(config.domain_id);
    const userId = config.userId || Tools.getUserId(config.domain_id);
    const that = this;
    if (sessionId) {
      var confix = {
        url: `${config.domainAPI}/chat/${sessionId}/get_message?per_page=20`,
        method: 'GET',
        body: ''
      };
      var headers = { cid: userId };

      BaseAPI.callAPI(
        confix,
        headers,
        response => {
          config.dataLoaded = true;
          const dataMess = response;
          if (dataMess.code == 200) {
            if (!dataMess.data || !dataMess.data.length) {
              return;
            }
            config.dataMess = dataMess;
            config.afterToken = dataMess.data[0].mid;
            that.expView && that.expView.updateDataMessage(dataMess);
          } else if (dataMess.code == -1) {
            Tools.deleteAllCookies();
            window.localStorage.clear();
            that.socketManager.disconnect();
          } else if ($el.find('.mo-chat-frame')[0]) {
            $el
              .find('.mo-chat-frame')[0]
              .style.setProperty('display', 'none', 'important');
          }
        },
        error => {
          console.log('error', error);
        }
      );
    }
  },

  endConversation() {
    this.socket.disconnect();
  },

  handleChatOpen() {
    const { frameBody, config, model } = this;
    this.openChatPanel();
    if (md.mobile()) {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
    }
  },

  handleChatClose() {
    this.closeChatPanel();
    if (md.mobile()) {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  },

  closeChatPanel() {
    const { pfx, config, model } = this;
    this.config.displayChat = false;
    this.expView.hide();
    this.minimizeModel.set('isChatOpen', false);
    this.minimizeModel.set('processing', true);
    this.minimizeView.finishClose();

    if (md.mobile) {
      this.frame.resetFullScreen();
    }
  },

  handleGreeting() {
    const { config } = this;
    const userId = config.userId || Tools.getUserId(this.config.domain_id);
    if (
      !this.config.isShowGreeting ||
      !this.config.widget_config.mobiochat ||
      config.greeting
    ) {
      return;
    }
    if (userId) {
      config.greeting = 1;
      const params = {
        url: `${this.config.domainAPI}/chat/${this.config.domain_id}/message_welcome`,
        method: 'POST',
        body: { url: window.location.href }
      };
      const headers = { cid: userId };
      config.flagGreeting = true;
      BaseAPI.callAPI(
        params,
        headers,
        response => {
          Tools.setGreeting(config.domain_id);
          config.greeting = 1;
        },
        error => {
          console.log('error', error);
          config.greeting = undefined;
        }
      );
    }
  },

  handleStopGreeting() {
    if (this.openchat) {
      clearTimeout(this.openchat);
      this.openchat = undefined;
    }
  },

  renderMinimizeChatPanel() {
    this.frameBody.append(this.minimizeView.render().el);
  },

  handleNumberMess(number) {
    this.minimizeView.handleNumberMessChange(number);
  },

  openChatPanel() {
    const { config, model, frame } = this;
    const expOpen = this.expModel && this.expModel.get('open');
    if (expOpen) {
      return;
    }
    config.displayChat = true;
    // this.frameBody.html('');
    this.handleNumberMess(0);
    model.set('minimize', false);
    model.set('numberMess', 0);

    if (md.mobile()) {
      frame.setFullScreen();
    } else {
      const width = parseInt(config.width) + 16 + 16 * 2;
      const height = parseInt(config.height) + 85 + 20;
      frame.updateDim(`${width}px`, `${height}px`);
    }

    this.minimizeModel.set('processing', true);
    this.minimizeModel.set('isChatOpen', true);

    setTimeout(() => {
      this.minimizeModel.set('processing', false);
    }, 200);

    this.expView.show();
    // this.bodyEl.css({'overflow': 'hidden'});
  },

  initExpandChatPanel() {
    const { frameBody, model } = this;

    this.expModel = new ExpandChatPanelModel(this.config);
    this.expView = new ExpandChatPanelView({
      model: this.expModel,
      config: this.config
    });

    this.listenTo(this.expModel, 'onChatClose', this.handleChatClose);
    this.listenTo(this.expModel, 'sendMessage', this.handleSendMessage);
    this.listenTo(this.expModel, 'emitAllVisitor', this.handleEmitAllVisitor);
    this.listenTo(this.expModel, 'endConversation', this.endConversation);

    this.expView.render();
    frameBody.append(this.expView.el);
  },

  handleSendMessage(data) {
    this.socketManager.sendMessage(data, this.sendMessageCallback);
  },

  handleEmitAllVisitor(data) {
    this.socketManager.emitAllVisitor(data);
  },

  sendMessageCallback(val, data) {
    val.id = data.id;
    this.expView.updateMessage(val);
  },

  initWindowEvent() {
    const that = this;
    window.addEventListener('blur', function() {
      that.handleStopTime();
      // that.handleStopGreeting();
    });

    window.addEventListener('beforeunload', function(event) {
      const { config } = that;
      const index = window.localStorage.getItem(
        'focusTime' + config.domain_id + window.location.href
      );
      if (that.socketManager.isConnected()) {
        that.socketManager.emit(
          'send_focus_time',
          { focus_time: index },
          function(val) {}
        );
      }

      window.localStorage.removeItem(
        'focusTime' + config.domain_id + window.location.href
      );
    });

    window.addEventListener('focus', function() {
      const { config } = that;
      that.focusTime();
      config.focusTime = true;
      const greeting = Tools.getGreeting(config.domain_id);
      if (!greeting) {
        // that.handleStopGreeting();
        if (config.time_popup > 0) {
          this.openchat = setTimeout(() => {
            that.handleGreeting();
          }, 1000 * config.time_popup);
        }
      }
    });
  },

  focusTime() {
    const { focusTime, config } = this;
    const index = window.localStorage.getItem(
      'focusTime' + config.domain_id + window.location.href
    );
    timefocusLink = setTimeout(() => {
      window.localStorage.setItem(
        'focusTime' + config.domain_id + window.location.href,
        index ? Number(index) + 1 : 1
      );
      if (config.focusTime) {
        focusTime();
      }
    }, 1000);
  },

  handleStopTime() {
    this.config.focusTime = false;
    timefocusLink = '';
    clearTimeout(timefocusLink);
  },

  render() {
    this.bodyEl = $('body');
    this.config.canvas = this;

    this.minimizeModel = new MinimizePanelModel(this.config);
    this.minimizeView = new MinimizePanelView({
      model: this.minimizeModel,
      config: this.config,
      flag: true
    });

    this.listenTo(this.minimizeModel, 'onChatOpen', this.handleChatOpen);
    this.listenTo(this.minimizeModel, 'onChatClose', this.handleChatClose);

    this.bodyEl.append(this.$el);

    this.frame = new FrameView({
      model: this.model.get('frame'),
      config: this.config
    });
    this.$el.append(this.frame.render().el);
    this.isFrameRender = true;

    return this;
  }
});
